
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './lib/react-query';
import App from './App.tsx';
import './index.css';
import { AuthProvider } from './contexts/AuthContext';
import { ErrorBoundary } from './components/ErrorBoundary';
import { Toaster } from './components/ui/toaster';
import { ContentManagerProvider } from './state/content/ContentManagerProvider';
import { LinkedInOAuthHandler } from './components/linkedin/LinkedInOAuthHandler';

// Prevent React errors from crashing the entire app
createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ContentManagerProvider>
          <LinkedInOAuthHandler />
          <App />
          <Toaster />
        </ContentManagerProvider>
      </AuthProvider>
    </QueryClientProvider>
  </ErrorBoundary>
);
